import { render, staticRenderFns } from "./BaremeAjuste.vue?vue&type=template&id=5349a798&scoped=true&"
import script from "./BaremeAjuste.vue?vue&type=script&lang=js&"
export * from "./BaremeAjuste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349a798",
  null
  
)

export default component.exports